import styles from '@/common/containers/ModuleOverview/styles.less';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const Legal = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.blockBody}>
      <h4 className={styles.contentTitle}>
        {t('Legal tasks module overview')}
      </h4>
      <div className={styles.contentDescription}>
        <ul>
          <ol>
            <Trans
              i18nKey="<1>Legal tasks</1> will assist you with obtaining or confirming the legal authority required to manage an estate."
              components={{ 1: <b /> }}
            />
          </ol>
          <br />
          <div className="note">
            {t(
              'Note: The content in this product is for informational purposes only and does not constitute legal advice. You should not act or refrain from acting based on the information on this product without seeking legal counsel from a licensed professional in your jurisdiction.'
            )}
          </div>
        </ul>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Instructions')}</h3>
      <div className={styles.contentStepper}>
        <Stepper orientation="vertical">
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t(
                'Complete all tasks on the “Legal tasks List”. (Ensure to annotate each task step as “Completed” once done)'
              )}
            </StepLabel>
          </Step>
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t('Complete the “Legal tasks Questionnaire”.')}
            </StepLabel>
          </Step>
        </Stepper>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Timeframe')}</h3>
      <div className={styles.contentTimeFrame}>
        <ul>
          <ol>
            <Trans
              i18nKey="1. <1>Legal tasks</1> should be started as soon as possible and ideally within 30 days of the date of death."
              components={{ 1: <b /> }}
            />
          </ol>
          <ol>
            <Trans
              i18nKey="2. <1>Legal tasks</1> should be completed prior to starting the <2>Main tasks</2> and <3>Assets tasks</3> as some tasks are dependent on having obtained the legal authority to complete them."
              components={{ 1: <b />, 2: <b />, 3: <b /> }}
            />
          </ol>
        </ul>
      </div>
      <div className={styles.contentNoteWrap}>
        <div className="note">
          {t(
            'Legal tasks may take weeks to complete so they should be initiated as soon as possible after Immediate tasks have been started. Ideally, Legal tasks should be started within 30 days of the date of death.'
          )}
        </div>
      </div>
    </div>
  );
};

export default Legal;
